import { SpaceColumns } from '@miq/catalog';

/**
 * Default configuration for initial Space entity filters
 */
export interface SpaceDefaultFilterConfigEntry {
  field: string;
  values: any[];
  type?: string;
  dataType?: string;
  name?: string;
}

export const SPACE_DEFAULT_FILTER_CONFIG: Record<number, SpaceDefaultFilterConfigEntry> = {
  [SpaceColumns.SpaceDetails_SpaceStatus]: {
    field: 'ref_space_availability_status_desc',
    values: ['Vacant', 'Leased'],
    type: 'multi',
    dataType: 'text',
    name: 'Space Status',
  },
  [SpaceColumns.SpaceDetails_Possession]: {
    field: 'ref_possession_type_desc',
    values: ['(empty)', 'Future Vacancy', 'Surrender/Sublet', 'Available'],
    type: 'multi',
    dataType: 'text',
    name: 'Possession',
  },
};
export const SPACE_STATUS_FILTER_KEY = SpaceColumns.SpaceDetails_SpaceStatus;
export const SPACE_POSSESSION_FILTER_KEY = SpaceColumns.SpaceDetails_Possession;

export const isSpaceEntity = (entity: string): boolean => entity === 'space';

export const isValidSpaceStatusValues = (values: unknown): values is readonly string[] =>
  Array.isArray(values) && values.length === 2 && values.includes('Vacant') && values.includes('Leased');
